import { render, staticRenderFns } from "./PainelProadi.vue?vue&type=template&id=022313c0"
import script from "./PainelProadi.vue?vue&type=script&lang=js"
export * from "./PainelProadi.vue?vue&type=script&lang=js"
import style0 from "./PainelProadi.vue?vue&type=style&index=0&id=022313c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports